import React from 'react';
import LocalsPlus from './tv/localsplus';
import CompleteLite from './tv/completelite';
import Complete from './tv/complete';
import AdvancedLite from './tv/advancedlite';
import Advanced from './tv/advanced';
import Ultra from './tv/ultra';
import HBO from './tv/hbo';
import Cinemax from './tv/cinemax';
import Showtime from './tv/showtime';
import StarzEncore from './tv/starzencore';
import Starz from './tv/starz';
import Encore from './tv/encore';
import VarietyPackLite from './tv/varietypacklite';
import VarietyPack from './tv/varietypack';
import SportsExtra from './tv/sportsextra';
import TeamSports from './tv/teamsports';
import OutdoorSports from './tv/outdoorsports';
import { Row, Col } from 'reactstrap';

const Tv = () => (
  <div>
    <h2>Channel Information</h2>
    <p>Below you can see channel information for each of our various HD TV package options as well as package add-ons.
       Click the show details link to see the full channel list in each section. TV Pricing reflects base package price.
       There are additional charges for extra set top boxes and DVRs. Excludes applicable taxes, franchise fees and
       broadcast fees. TV Powered by Co-Mo Connect.</p>
       <br />
    <hr />
    <h4>Base TV Packages</h4>
    <hr />
    <LocalsPlus />
    <Row>
      <Col sm="6">
        <CompleteLite />
      </Col>
      <Col sm="6">
        <Complete />
      </Col>
    </Row>
    <Row>
      <Col sm="6">
        <AdvancedLite />
      </Col>
      <Col sm="6">
        <Advanced />
      </Col>
    </Row>
    <Ultra />
    <br />
    <hr />
    <h4>TV Package Add Ons - Premium Movie Channels</h4>
    <hr />
    <Row>
      <Col sm="4">
        <HBO />
      </Col>
      <Col sm="4">
        <Cinemax />
      </Col>
      <Col sm="4">
        <Showtime />
      </Col>
    </Row>
    <Row>
      <Col sm="4">
        <StarzEncore />
      </Col>
      <Col sm="4">
        <Starz />
      </Col>
      <Col sm="4">
        <Encore />
      </Col>
    </Row>
    <br />
    <hr />
    <h4>TV Package Add Ons - Variety Packs</h4>
    <hr />
    <Row>
      <Col sm="6">
        <VarietyPackLite />
      </Col>
      <Col sm="6">
        <VarietyPack />
      </Col>
    </Row>
    <br />
    <hr />
    <h4>TV Package Add Ons - Premium Sports Channels</h4>
    <hr />
    <Row>
      <Col sm="4">
        <SportsExtra />
      </Col>
      <Col sm="4">
        <TeamSports />
      </Col>
      <Col sm="4">
        <OutdoorSports />
      </Col>
    </Row>
  </div>
);

export default Tv;


// WEBPACK FOOTER //
// ./src/components/sections/services/tv.js